import script from "./ak.vue?vue&type=script&lang=ts&setup=true"
export * from "./ak.vue?vue&type=script&lang=ts&setup=true"

import "./ak.vue?vue&type=style&index=0&id=24935c97&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24935c97"]])

export default __exports__